import { useUser } from "../context/UserContext";
import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import NavBar from "../components/NavBar/NavBar";

const AppLayout = ({ children }) => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.accessToken) {
      navigate({ to: "/login" , resetScroll: true});
    }
  }, [navigate, user]);

  return (
    <div className="flex flex-col">
      <NavBar />
      <main className="pt-16">{children}</main>
    </div>
  );
};

export default AppLayout;
